import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    employeeChannel = new Subject();
    polaKerjaChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.employeeChannel.next({status: apiResponse.INITIAL})
        this.polaKerjaChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchEmployee = async (query) => {
        try {
            this.employeeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployee(query).then((result) => {
                this.employeeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchPolaKerja = async (query) => {
        try {
            this.polaKerjaChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPolaKerja(query).then((result) => {
                this.polaKerjaChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.polaKerjaChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }
}

export default CreateBloc